/**
 * Definitions for the webapp.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025
 */
import { Util } from '@amplify3/duplo-back-end'

export const baseURL = import.meta.env.VITE_API_BASE_URI
export const isEnvProduction = Util.isEnvProduction(baseURL)
